import React from "react";
import { AppBar, TextField, Typography } from "@mui/material/";
import { strings } from "../../../common/i18n";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MatReactTable from "../../../common/components/MaterialReactTable";
import useColumnsRows from "./useColumnsRows";
import styles from "../styles";

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vin-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography component={"span"}>{children}</Typography>
                </Box>
            )}
        </div>
    );
};

/**
 * Right Panel Tabs  Component
 */
export default ({
    identifiers,
    selectedAssets,
    setSelectedAssets,
    value,
    onChange,
    handleTabChange
}) => {
    const { columns, data } = useColumnsRows();

    return (
        <>
            <AppBar position="static" color="default">
                <Tabs
                    value={value}
                    onChange={handleTabChange}
                    aria-label="select entry"
                >
                    <Tab
                        label={strings("selectAssets")}
                        id={`exclude-tab-0`}
                        aria-controls={`exclude-tabpanel-0`}
                    />
                    <Tab
                        label={strings("enterList")}
                        id={`exclude-tab-1`}
                        aria-controls={`exclude-tabpanel-1`}
                    />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <Box sx={styles.tabPanelContainer}>
                    <MatReactTable
                        persistKey="auditExcludeAssets"
                        columns={columns}
                        data={data}
                        loading={false}
                        rowSelection={true}
                        onSelectionChange={(selectedRowData) =>
                            setSelectedAssets(
                                selectedRowData.map((row) => row.id)
                            )
                        }
                        noRowsMessage={strings("messages.noCheckedAsset")}
                    />
                </Box>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <TextField
                    fullWidth
                    margin="normal"
                    multiline
                    onChange={onChange("identifiers")}
                    placeholder={`${strings("messages.enterList")}`}
                    minRows={8}
                    maxRows={10}
                    value={identifiers}
                    variant="outlined"
                />
            </TabPanel>
        </>
    );
};
